// extracted by mini-css-extract-plugin
module.exports = {"content":"error-template_content__Pg_pC","title":"error-template_title__BBFtm typographyHeadlineMedium","description":"error-template_description__4cP_i typographyBodyMedium"};